module.exports = __webpack_public_path__ + "static/media/cotm.861caa54.jpg";